import { useSelector } from "react-redux";
import { Box, Paper, Skeleton } from "@mui/material";
import { DocumentList, StepActionsExpediente } from "@components/ui_v2";
import { RootState, useAppDispatch } from "@store/store";
import { setExpedienteDictamenDoc } from "@store/slices/expedienteSlice";
import { validateRequiredDocumentsAreUploaded } from "@components/TabBofu/functions";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";

export const TabDictamen = () => {
  const dispatch = useAppDispatch();

  const dictamen = useSelector((state: RootState) => state.expediente.dictamen);
  const isLoading = useSelector((state: RootState) => !state.expediente.tabsReady);

  const documentos = dictamen.documents;

  return (
    <Box>
      {isLoading ? (
        <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Paper variant="lendia_paper" sx={{ p: "20px 22px" }}>
              <DocumentList
                documents={documentos}
                onChange={({ document, newValue }) =>
                  dispatch(setExpedienteDictamenDoc({ document, newValue, valueAction: undefined, valueIndex: undefined }))
                }
                onChangeMultiple={({ document, newValue, valueAction, valueIndex }) =>
                  dispatch(setExpedienteDictamenDoc({ document, newValue, valueAction, valueIndex }))
                }
              />
            </Paper>
          </Box>

          <StepActionsExpediente
            currentTab={BOFU_TABS_CONFIG.tab_dictamen.code}
            nextDisabled={!validateRequiredDocumentsAreUploaded(documentos)}
          />
        </Box>
      )}
    </Box>
  );
};
